
import React, { useState, useEffect } from "react";
import { ButtonPrimary } from "../Buttons";
import Input from "../Input";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { readQuizzes, updateQuizPDF } from "../../control/QuizData";
import { Form } from "react-bootstrap";

function QuizEdit(props) {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    specTitle: "",
    pdfLink: "",
    timeSlot: "",
    location: "",
    date: "",
  });

  const [quizOptions, setQuizOptions] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);

  const fetchQuizzes = async () => {
    const quizzes = await readQuizzes();
    const options = quizzes.map((quiz) => ({
      value: quiz.id,
      label: quiz.title,
    }));
    setQuizOptions(options);
  };

  const fetchQuizDetails = async (quizId) => {
    const quizzes = await readQuizzes();
    const selectedQuizData = quizzes.find((quiz) => quiz.id === quizId);

    setValues({
      specTitle: selectedQuizData.title,
      pdfLink: selectedQuizData.PDF || "",
      timeSlot: selectedQuizData.timeSlot || "",
      location: selectedQuizData.location || "",
      date: selectedQuizData.date || "",
    });
  };

  useEffect(() => {
    fetchQuizzes();
  }, []);

  useEffect(() => {
    if (selectedQuiz) {
      fetchQuizDetails(selectedQuiz.value);
    }
  }, [selectedQuiz]);

  const handleInputChange = (field, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleEdit = async () => {
    if (!selectedQuiz) {
      alert("Please select a quiz to edit.");
      return;
    }

    const quizId = selectedQuiz.value;
    if (values.pdfLink) {
      await updateQuizPDF(quizId, values.pdfLink);
    }

    alert("Quiz updated successfully.");
    navigate("/faculty/dashboard");
  };

  const handleCancel = () => {
    navigate("/faculty/dashboard");
  };

  return (
    <div className="QuizEdit" {...props}>
      <h3>Edit Quiz</h3>

      <label>Select Quiz</label>
      <Select
        options={quizOptions}
        value={selectedQuiz}
        onChange={(selectedOption) => setSelectedQuiz(selectedOption)}
        placeholder="Select a quiz"
      />

      <label>PDF Link</label>
      <Input
        placeholder="Enter Link"
        value={values.pdfLink}
        onChange={(event) => handleInputChange("pdfLink", event.target.value)}
      />

      <label>Time Slot</label>
      <Form.Select
        value={values.timeSlot}
        onChange={(e) => handleInputChange("timeSlot", e.target.value)}
      >
        <option value="">Select Time</option>
        {[
          "7:30 AM", "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM", "10:00 AM",
          "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM",
          "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM",
          "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM",
          "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM", "9:00 PM",
        ].map((time) => (
          <option key={time} value={time}>{time}</option>
        ))}
      </Form.Select>

      <label>Location</label>
      <Select
        options={[
          { value: "B-1212", label: "B-1212" },
          { value: "B-1213", label: "B-1213" },
          { value: "B-1214", label: "B-1214" },
          { value: "B-1215", label: "B-1215" },
        ]}
        value={
          values.location
            ? { value: values.location, label: values.location }
            : null
        }
        onChange={(selectedOption) =>
          handleInputChange("location", selectedOption.value)
        }
      />

      <label>Date</label>
      <Input
        type="date"
        value={values.date}
        onChange={(event) => handleInputChange("date", event.target.value)}
      />

      <div className="containerHorizontal" style={{ justifyContent: "right" }}>
        <p
          className="cancel"
          style={{ marginRight: "15px", cursor: "pointer" }}
          onClick={handleCancel}
        >
          Cancel
        </p>
        <ButtonPrimary
          text="Edit"
          onClick={handleEdit}
          style={{ width: "fit-content" }}
        />
      </div>
    </div>
  );
}

export default QuizEdit;
    